import Alpine from 'alpinejs';
document.addEventListener('alpine:init', () => {
    Alpine.data('initPopinBlog', () => {
        return {
            showPopin: false,
            init() {
                const fullHeight = document.documentElement.scrollHeight;
                window.addEventListener('scroll', () => {
                    const calcPercentage = ((window.pageYOffset || document.documentElement.scrollTop) / fullHeight) * 100
                    const hidePopinForSession = window.sessionStorage.getItem("hide_popin");
                    if (calcPercentage >= 50 && hidePopinForSession != "true") {
                        this.showPopin = true;
                        return
                    }
                })
            },
            hidePopin() {
                window.sessionStorage.setItem("hide_popin", "true");
                this.showPopin = false;
            }
        };
    });
});
